import React from "react";
import { Input } from "antd";
import { TextareaEventProps } from "../../../../../../API/evaluate";
import useDeviceType from "../../../../../../Utils/useDeviceType";

interface Props extends TextareaEventProps {}

const { TextArea } = Input;
const Index = ({ onChange, value, onSave, ...restProps }: Props) => {
    const { isPC } = useDeviceType();

    return (
        <TextArea
            {...restProps}
            rows={isPC ? 10 : 5}
            onChange={event => {
                onChange?.(event.target.value);
            }}
            onBlur={event => {
                onSave?.(event.target.value);
            }}
            placeholder="请输入"
            value={value}
        />
    );
};

export default Index;
